import { render, staticRenderFns } from "./PosNewDashboard.vue?vue&type=template&id=ef3f191c&scoped=true"
import script from "./PosNewDashboard.vue?vue&type=script&lang=js"
export * from "./PosNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./PosNewDashboard.vue?vue&type=style&index=0&id=ef3f191c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3f191c",
  null
  
)

export default component.exports